import { MessageEvents } from "../events/EventEnums";
import {
  JackpotHistoryAckMessage,
  JackpotHitAckMessage,
  MessageType,
  ParametersAckMessage,
  ProgressiveCurValuesAckMessage,
  WebSocketMessage,
} from "../models/Messages";
import GlobalStore from "./GlobalStore";
import { WebSocketClient } from "./WebSocketClient";

export class WebSocketMessageHandler {
  private readonly wsClient: WebSocketClient;

  constructor(wsClient: WebSocketClient) {
    this.wsClient = wsClient;
  }

  public handle = (data: string | object) => {
    if (!isObject(data) || !isWebSocketMessage(data)) {
      if (!(typeof data === "string" && data.startsWith("echo - "))) {
        console.error("Unexpected websocket message");
      }
      return;
    }

    const msgEE = GlobalStore.messageEventEmitter;
    switch (data.msgType) {
      case MessageType.PARAMETERS: {
        msgEE.emit(MessageEvents.MESSAGE_PARAMETERS, data);
        const acknowledge: ParametersAckMessage = {
          msgType: MessageType.PARAMETERS_ACK,
          eventId: data.eventId,
          signId: GlobalStore.getSignId(),
        };
        this.wsClient.send(acknowledge);
        break;
      }
      case MessageType.JACKPOT_HISTORY: {
        msgEE.emit(MessageEvents.MESSAGE_JACKPOT_HISTORY, data);
        const acknowledge: JackpotHistoryAckMessage = {
          msgType: MessageType.JACKPOT_HISTORY_ACK,
          eventId: data.eventId,
          signId: GlobalStore.getSignId(),
        };
        this.wsClient.send(acknowledge);
        break;
      }
      case MessageType.JACKPOT_HIT: {
        msgEE.emit(MessageEvents.MESSAGE_JACKPOT_HIT, data);
        const acknowledge: JackpotHitAckMessage = {
          msgType: MessageType.JACKPOT_HIT_ACK,
          eventId: data.eventId,
          signId: GlobalStore.getSignId(),
        };
        this.wsClient.send(acknowledge);
        break;
      }
      case MessageType.PROGRESSIVE_CUR_VALUES: {
        msgEE.emit(MessageEvents.MESSAGE_PROGRESSIVE_CUR_VALUES, data);
        const acknowledge: ProgressiveCurValuesAckMessage = {
          msgType: MessageType.PROGRESSIVE_CUR_VALUES_ACK,
          timestamp: new Date().getTime(),
          signId: GlobalStore.getSignId(),
        };
        this.wsClient.send(acknowledge);
        break;
      }
    }
  };
}

function isObject(o: any): o is Record<string, any> {
  return o !== null && typeof o === "object";
}

function isWebSocketMessage(obj: any): obj is WebSocketMessage {
  return isObject(obj) && typeof obj.msgType === "number";
}
